import {Button, Form, Modal} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import AdhocImageUpload from "./AdhocImageUpload";
import AdhocImageGallary from "./AdhocImageGallary";
import {createPropertyInstruction, getPropertyInstruction} from "../service/PropertyService";

export function InstructionModel({show, property, modelType, handleSave, handleClose}) {
    const [instruction, setInstruction] = useState({description: "", images: []});
    const [isLoading, setIsLoading] = useState(false);
    const refreshInstruction = () => {
        if (modelType) {
            setIsLoading(true);
            getPropertyInstruction(property.property_id, modelType.toLowerCase()).then(response => {
                if (response.status === 200) {
                    response.json().then(data => {
                        setInstruction(data);
                    });
                } else {
                    //If no instruction is found, no error, just
                }
            }).finally(() => setIsLoading(false));
        }
    };

    const instructionDate = instruction.date ? new Date(instruction.date) : new Date();
    const localDate = instructionDate.toLocaleString();

    useEffect(() => {
        refreshInstruction();
    }, [property, modelType]);

    return (
        <Modal show={show} onHide={handleClose} dialogClassName="custom-modal-width">
            <Form>
                <Modal.Header closeButton>
                    <Modal.Title>{modelType} Instructions</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="address">
                        <Form.Label>Property Address:</Form.Label>
                        <Form.Control type="text" placeholder="Enter Address"
                                      value={property.full_address}
                                      disabled/>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="address">
                        <Form.Label>Updated Date:</Form.Label>
                        <Form.Control type="text" placeholder="Enter Address"
                                      value={localDate}
                                      disabled/>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="instructions">
                        <Form.Label>{modelType} Instruction</Form.Label>
                        <Form.Control type="text" placeholder="Enter Instructions"
                                      value={instruction.description}
                                      onChange={(e) => setInstruction({...instruction, description: e.target.value})}
                        />
                        <Form.Text className="text">
                            Please type instruction to help the worker
                        </Form.Text>
                    </Form.Group>
                </Modal.Body>
                <div style={{marginLeft: 20, marginRight: 20}}>
                    <AdhocImageUpload images={instruction.images}
                                      setImages={(images) => setInstruction({...instruction, images})}/>
                    <AdhocImageGallary images={instruction.images}
                                       setImages={(images) => setInstruction({...instruction, images})}/>
                </div>
                <Modal.Footer>
                    <Button variant="secondary"
                            disabled={isLoading}
                            onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary"
                            disabled={isLoading}
                            onClick={() => handleSave(property, instruction, modelType.toLowerCase())}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};
